<template>
  <div>
    <div class="header">
      <div class="container-fluid container-boxed">
        <div class="header-body">
          <h6 class="header-pretitle">Overview</h6>
          <h1 class="header-title">Home</h1>
        </div><!-- / .header-body -->
      </div>
    </div><!-- / .header -->

    <dashboard-graduate v-if="$userIsGraduate"/>
    <dashboard-manager v-if="$userIsManager"/>
    <dashboard-coordinator v-if="$userIsCoordinator"/>
    <dashboard-admin v-if="$userIsAdmin"/>
  </div>
</template>

<script>
import DashboardGraduate from './DashboardGraduate'
import DashboardManager from './DashboardManager'
import DashboardCoordinator from './DashboardCoordinator'
import DashboardAdmin from './DashboardAdmin'

export default {
  components: {
    DashboardGraduate,
    DashboardManager,
    DashboardCoordinator,
    DashboardAdmin
  }
}
</script>
